import React from "react";
import "./Footer.css";
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";

const RentalFooter = () => {
  return (
    <footer className="rental-footer">
      <div className="rental-footer-container">

        {/* Brand Section */}
        <div className="rental-footer-col">
          <img src={require("../Images/dhanushdhari_final_log.jpeg")} alt="Dhanushdhari Rental Logo" className="footer-logo" height="100px" />
          <p className="footer-desc">
            Find the best rental properties, apartments, and houses at the most
            affordable prices. Trusted by thousands of happy tenants.
          </p>

          <div className="footer-social">
            <a href="#"><FaFacebookF /></a>
            <a href="#"><FaInstagram /></a>
            <a href="#"><FaTwitter /></a>
            <a href="#"><FaYoutube /></a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="rental-footer-col">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/">Properties</a></li>
            <li><a href="/">Gallery</a></li>
            <li><a href="/">Contact</a></li>
          </ul>
        </div>

        {/* Categories */}
        <div className="rental-footer-col">
          <h3>Rental Categories</h3>
          <ul>
            <li><a href="#">Apartments</a></li>
            <li><a href="#">Villas</a></li>
            <li><a href="#">Offices</a></li>
            <li><a href="#">Commercial</a></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="rental-footer-col">
          <h3>Contact</h3>
          <p>📍 Kolkata, India</p>
          <p>📞 +91 9876543210</p>
          <p>✉ support@dhanushdharirental.com</p>
        </div>

      </div>

      <div className="footer-bottom">
        <p>© 2026 House of Dhanushdhari Rental. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default RentalFooter;